import { IProduct, IProductWeight } from '@/storePinia/interfaces/IProduct/IProduct';
import { useBasketStore } from '@/storePinia/stores/basket';
import { IProductStore } from '@/storePinia/stores/product/interfaces/IProductStore';
import axios from 'axios';
import useLoader from '@use/useLoader/useLoader';
import { useResultsStore } from '@/storePinia/stores/results';

const basketStore = useBasketStore();
const resultsStore = useResultsStore();
const loader = useLoader();

interface IUseSKU {
  selectWeight: (weight: IProductWeight, product: IProduct) => Promise<IProductStore | undefined>;
  getProductPageDataUsingUrl: (url: string) => Promise<IProductStore | undefined>;
}

export function useSKU(): IUseSKU {
  const selectWeight = async (weight: IProductWeight, product: IProduct) => {
    if (!product.detailPage) return undefined;

    const offerId = product.offer?.id;

    const productData: IProductStore = await basketStore.changeProductWeightPrice(
      product.detailPage,
      {
        price: +weight.dbPrice,
        weightOption: weight.weightOption,
        weight: +weight.weight,
        barcode: +weight.barcode,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        OFFER_ID: offerId,
      }
    );

    return productData;
  };

  const getProductPageDataUsingUrl = async (url: string) => {
    try {
      loader.start();

      const { data } = await axios.get(url, {
        params: {
          api: 'Y',
          ...resultsStore.getRequestLang,
        },
      });

      return data;
    } catch (error) {
      console.error(error);
      return undefined;
    } finally {
      loader.stop();
    }
  };

  return {
    getProductPageDataUsingUrl,
    selectWeight,
  };
}
